import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
// import classnames from 'classnames';

import Navigation from '../../../components/WaveNavigation';

export default (props) => {
  return (
    <div>
      <Helmet
        title="Fire Island Ferries | Labor Day Weekend Freight"
        meta={[
          {
            name: 'description',
            content: 'Fire Island Ferries Contact Information',
          },
          {
            name: 'keywords',
            content: 'Fire Island, New York, Long Island, Ferries, Water Taxi',
          },
        ]}
      />
      <Navigation />
      <div className="container page">
        <div className="row">
          <div className="col-xl">
            <div className="heading">
              <h2>Freight Info</h2>
              <h1>2024 Labor Day Weekend Info</h1>
            </div>
            <p>
              Listed below are the APPROXIMATE freight times for Labor Day
              Weekend. These times are subject to change without notice but
              should remain fairly accurate.
            </p>
            <p>
              <strong>
                Have all items in sealed containers and labeled with your full
                name and "Bay Shore".
              </strong>
            </p>
            <p>
              We ask that you pay at the freight boat when dropping your returns off. Either hold on to your receipt or send a picture of it to whomever is picking your items up for you in Bay Shore. All returns can be gathered from the freight house which is in the main terminal (Gate 1) across from the office building.
            </p>
            <p>
              All bicycles, wagons, windsurfers, surfboards, grills, propane
              tanks, patio furniture, gas powered tools, etc. will be left
              outside and the Fire Island Ferries will NOT be responsible for
              any items left outside overnight.
            </p>
            <p>
              <strong>
                Boats will arrive back in Bay Shore (Main Terminal) at
                approximately 2:30 PM on Saturday and 3:00pm on Monday. The freight house in Bay Shore will be
                open until 5:00 PM Saturday, August 31. Sunday, September
                1 it will be open 10:00am to 5:00pm. The Bay Shore freight house will be open for pick up until 7:00pm Monday, September 2 (Labor Day)
              </strong>
            </p>
            <p>
              Thank you for using our service! We hope you have a happy and
              healthy fall, winter and spring and look forward to seeing you all
              again next summer. Any questions feel free to call 631.647.3055 or
              email us at freight@fireislandferries.com. Be sure to follow{' '}
              <a href="https://www.twitter.com/fifreight">
                FIFI Freight Tracker
              </a>{' '}
              on Twitter for live updates on freight boat arrivals.
            </p>
          </div>
        </div>
        <hr />
        <div className="text-center">
          <h3>Saturday, August 31, 2024</h3>
          <h4>Leaves Bay Shore at 10:00am -- Arrives in Bay Shore at 2:30pm</h4>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Have Returns on the Dock By</th>
                  <th>Same Day Delivery</th>
                  <th>Freight House Hours</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Kismet</th>
                  <td>10:30am</td>
                  <td>10:45am</td>
                  <td>See Boat</td>
                </tr>

                <tr>
                  <th scope="row">Saltaire</th>
                  <td>10:45am</td>
                  <td>11:00am</td>
                  <td>See Boat</td>
                </tr>

                <tr>
                  <th scope="row">Fair Harbor</th>
                  <td>9:45am - 10:45am</td>
                  <td>12:00pm</td>
                  <td>12:15pm - 1:45pm</td>
                </tr>

                <tr>
                  <th scope="row">Dunewood</th>
                  <td>11:15am</td>
                  <td>12:00pm</td>
                  <td>See Boat</td>
                </tr>

                <tr>
                  <th scope="row">Atlantique</th>
                  <td colSpan="3">Please call if you have freight.</td>
                </tr>

                <tr>
                  <th scope="row">Ocean Beach</th>
                  <td>10:45am - 12:30pm</td>
                  <td>1:00pm</td>
                  <td>1:00pm - 3:20pm</td>
                </tr>

                <tr>
                  <th scope="row">Seaview</th>
                  <td>9:45am - 11:00am</td>
                  <td>1:00pm</td>
                  <td>1:00pm - 3:15pm</td>
                </tr>
                <tr>
                  <th scope="row">Ocean Bay Park</th>
                  <td>9:45am - 10:30am</td>
                  <td>12:30pm</td>
                  <td>12:30pm - 3:30pm</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h4>Pickup in Bay Shore until 5:00pm</h4>
        </div>

        <hr />
        <div className="text-center">
          <h3>Sunday, September 1, 2024</h3>
          <h4>
            *** NO FREIGHT BOAT ***
          </h4>
          <h4>Pickup in Bay Shore 10:00am - 5:00pm</h4>
        </div>
        <hr />
        <div className="text-center">
          <h3>Monday, September 2, 2024</h3>
          <h4>
            <span style={{ color: 'red' }}>
              ** Leaves Bay Shore at 9:00am **
            </span>{' '}
            -- Arrives in Bay Shore at 3:00pm
          </h4>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Have Returns on the Dock By</th>
                  <th>Same Day Delivery</th>
                  <th>Freight House Hours</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Kismet</th>
                  <td>9:45am</td>
                  <td>10:00am</td>
                  <td>See Boat</td>
                </tr>

                <tr>
                  <th scope="row">Saltaire</th>
                  <td>10:15am</td>
                  <td>10:30am</td>
                  <td>See Boat</td>
                </tr>

                <tr>
                  <th scope="row">Fair Harbor</th>
                  <td>9:45am - 10:45am</td>
                  <td>11:45am</td>
                  <td>9:45am - 1:45pm</td>
                </tr>

                <tr>
                  <th scope="row">Dunewood</th>
                  <td>11:15am</td>
                  <td>11:45am</td>
                  <td>See Boat</td>
                </tr>

                <tr>
                  <th scope="row">Atlantique</th>
                  <td colSpan="3">Please call if you have freight.</td>
                </tr>

                <tr>
                  <th scope="row">Ocean Beach</th>
                  <td>10:45am - 12:00pm</td>
                  <td>12:30pm</td>
                  <td>12:30pm - 1:30pm</td>
                </tr>

                <tr>
                  <th scope="row">Seaview</th>
                  <td>10:30am - 12:00pm</td>
                  <td>CALL DAY OF</td>
                  <td>10:30am - 1:45pm</td>
                </tr>
                <tr>
                  <th scope="row">Ocean Bay Park</th>
                  <td>10:45am - 12:00pm</td>
                  <td>CALL DAY OF</td>
                  <td>10:45am - 2:00pm</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h4>Pickup in Bay Shore until 7:00pm</h4>
        </div>
      </div>
    </div>
  );
};
